import axios, { endpoints } from "../../libs/axios";

export type UpdateCartApiOptions = {
  updatedItems: unknown[];
  couponCode?: string;
  /** When true, incoming items replace the server cart (edit/remove/sync). */
  replaceItems?: boolean;
  /** 0-based indexes to remove after merge (optional). */
  removedLineIndexes?: number[];
};

export const handleUpdateCart = async ({
  updatedItems,
  couponCode,
  replaceItems,
  removedLineIndexes,
}: UpdateCartApiOptions) => {
  try {
    const customPayload: Record<string, unknown> = {
      items: updatedItems,
      currency: "CAD",
      couponCode,
    };
    if (replaceItems === true) {
      customPayload.replaceItems = true;
    }
    if (removedLineIndexes?.length) {
      customPayload.removedLineIndexes = removedLineIndexes;
    }
    const response = await axios.put(endpoints.cart.update, customPayload);
    return response.data;
  } catch (error) {
    console.error("Failed to update cart", error);
    throw error;
  }
};

export const handleGetTaxApi = async (payload: any) => {
  try {
    const response = await axios.get(
      `${endpoints.cart.tax}?countryCode=${payload.billingCountry}&stateCode=${payload.billingState}`,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to log in", error);
    throw error;
  }
};

export const handleGetCartApi = async (payload: any) => {
  try {
    const response = await axios.get(endpoints.cart.get);
    if (response.data === "") {
      return {
        items: [],
        totalQuantity: 0,
        totalPrice: 0,
        discount: 0,
        couponCode: null,
      };
    }
    return response.data;
  } catch (error) {
    console.error("Failed to log in", error);
    throw error;
  }
};
